"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const omit_1 = __importDefault(require("lodash/omit"));
exports.default = (event) => (context) => __awaiter(void 0, void 0, void 0, function* () {
    const { result, params: { connection } } = context;
    if (!connection) {
        return context;
    }
    const service = context.service;
    Object.assign(connection, (0, omit_1.default)(result, 'accessToken', 'authentication'));
    yield service.handleConnection(event, connection, result);
    return context;
});
//# sourceMappingURL=connection.js.map